module.exports = __webpack_public_path__ + "img/confirmed.263b5672.png";